<template>
    <div id="collections-form">
        <div class="flex-grid flex-grid-stretch">
            <div :class="{ 'flex-lg-4': this.partnerTypeId === 1 }" class="flex-xs-12 flex-md-6">
                <div class="cr-form-group">
                    <span class="cr-form-group-title">1º passo: Dados básicos</span>

                    <label for="name">Nome:</label>
                    <input id="name" v-model="name" type="text" />

                    <label for="email">Email:</label>
                    <input id="email" v-model="email" type="email" />

                    <label for="phone">Telefone:</label>
                    <input id="phone" v-model="phone" type="phone" />

                    <label for="link">Link:</label>
                    <input id="link" v-model="link" type="text" />

                    <label>Arquivo com seu portfolio (opcional):</label>
                    <label class="btn btn-sm btn-light btn-wide mb" for="portfolio">
                        {{ portfolioButtonLabel }}
                        <input
                            id="portfolio"
                            ref="portfolioInput"
                            type="file"
                            @change="onPortfolioFileChanged($event)"
                        />
                    </label>
                    <small>Extensões permitidas: doc / pdf / jpg / png (Máx 6MB)</small>
                </div>
            </div>

            <div v-if="this.partnerTypeId === 1" class="flex-xs-12 flex-md-6 flex-lg-4">
                <div class="cr-form-group">
                    <span class="cr-form-group-title">2º passo: Dados complementares</span>

                    <label>Mídias que possui:</label>
                    <template v-for="(media, index) in medias">
                        <input
                            :id="`media-${index}`"
                            v-model="checkedMedias"
                            :value="media"
                            class="cr-checkbox"
                            type="checkbox"
                        />
                        <label :for="`media-${index}`">{{ media }}</label>
                    </template>

                    <label class="mt">Áreas de afinidade:</label>
                    <template v-for="(interest, index) in interests">
                        <input
                            :id="`interest-${index}`"
                            v-model="checkedInterests"
                            :value="interest"
                            class="cr-checkbox"
                            type="checkbox"
                        />
                        <label :for="`interest-${index}`">{{ interest }}</label>
                    </template>
                </div>
            </div>

            <div
                :class="{
                    'flex-md-12 flex-lg-4': this.partnerTypeId === 1,
                    'flex-md-6': this.partnerTypeId !== 1,
                }"
                class="flex-xs-12"
            >
                <div class="cr-form-group d-flex flex-column">
                    <span class="cr-form-group-title flex-child-fixed"
                        >{{ this.partnerTypeId !== 1 ? '2' : '3' }}º passo: Finalização</span
                    >

                    <label class="flex-child-fixed" for="proposal">Descreva sua proposta:</label>
                    <textarea id="proposal" v-model="proposal"></textarea>

                    <div class="text-center my flex-child-fixed">
                        <Alert :alert="errorAlert" />

                        <div id="partner-recaptcha" style="display: inline-block"></div>

                        <br />

                        <input
                            :disabled="submitted || submitting"
                            :value="submitLabel"
                            class="btn btn-lg btn-primary"
                            type="submit"
                            @click="onSubmitClicked"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Alert from '../../common/Alert';
    import { partnerService } from '../../../../common/service/resource';

    export default {
        name: 'PartnersPageForm',

        components: { Alert },

        props: {
            partnerTypeId: Number,
        },

        data() {
            return {
                name: '',
                email: '',
                link: '',
                phone: '',
                portfolioFile: null,
                proposal: '',
                checkedMedias: [],
                checkedInterests: [],
                medias: [
                    'Blog/Site',
                    'Facebook',
                    'Instagram',
                    'YouTube',
                    'Twitter',
                    'Tik Tok',
                    'Outros',
                ],
                interests: [
                    'Geek',
                    'Cinema e séries',
                    'Música',
                    'Literatura',
                    'Brasilidade',
                    'Humor',
                    'Moda & Beleza',
                    'Gaming',
                    'Educação',
                    'Esportes',
                    'Outros',
                ],
                errorAlert: {
                    message: null,
                    isError: true,
                },
                recaptchaResponse: null,
                recaptchaVerified: false,

                submitting: false,
                submitted: false,
            };
        },
        mounted() {
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute(
                'src',
                'https://www.google.com/recaptcha/api.js?onload=onLoadRecaptcha&render=explicit'
            );
            document.head.appendChild(recaptchaScript);

            window.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        },
        computed: {
            portfolioButtonLabel() {
                return this.portfolioFile
                    ? `"${this.portfolioFile.name}" anexado`
                    : 'Anexe clicando aqui';
            },
            submitLabel() {
                if (this.submitted) {
                    return 'Enviado';
                } else if (this.submitting) {
                    return 'Enviando...';
                } else {
                    return 'Enviar';
                }
            },
        },
        methods: {
            onLoadRecaptcha() {
                window.grecaptcha.render('partner-recaptcha', {
                    sitekey: '6Ld-GRMUAAAAABpupP5l5O3IdiEALCtwnja6wqf7',
                    callback: this.onRecaptchaSubmitted.bind(this),
                });
            },
            onRecaptchaSubmitted(response) {
                this.recaptchaResponse = response;
            },
            verifyCaptcha(callback) {
                if (!this.recaptchaResponse) {
                    this.showError('Não foi possível validar o captcha');
                    return;
                }

                this.submitting = true;
                this.axios.api
                    .post('/recaptcha/verify', {
                        response: this.recaptchaResponse,
                    })
                    .then((response) => {
                        this.submitting = false;

                        this.recaptchaVerified = response.data.success;

                        if (this.recaptchaVerified) {
                            if (callback) callback();
                        } else {
                            this.showError('Não foi possível validar o captcha');
                        }
                    })
                    .catch(() => {
                        this.submitting = false;
                        this.showError('Não foi possível validar o captcha');
                    });
            },
            onSubmitClicked() {
                if (this.recaptchaVerified) {
                    this.submit();
                } else {
                    this.verifyCaptcha(() => this.submit());
                }
            },
            submit() {
                if (this.validate()) {
                    this.sendEmail();
                } else {
                    this.showError('Preencha todos os campos');
                }
            },
            validate() {
                return this.partnerTypeId === 1 ? this.validatePartner() : this.validateArtist();
            },
            validateArtist() {
                return (
                    this.validateText(this.name) &&
                    this.validateText(this.email) &&
                    this.validateText(this.link) &&
                    this.validateText(this.phone)
                );
            },
            validatePartner() {
                return (
                    this.validateText(this.name) &&
                    this.validateText(this.email) &&
                    this.validateText(this.link) &&
                    this.validateText(this.phone) &&
                    this.checkedInterests.length > 0 &&
                    this.checkedMedias.length > 0
                );
            },
            validateText(text) {
                return text != null && text.trim().length > 0;
            },
            validateMedia(mediaType) {
                return [
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.oasis.opendocument.text',
                    'image/jpeg',
                ].contains(mediaType);
            },
            showSuccess(message, persist) {
                if (persist) {
                    this.errorAlert = {
                        message,
                        isError: false,
                        timeout: 0,
                    };
                } else {
                    this.errorAlert = {
                        message,
                        isError: false,
                    };
                }
            },
            showError(message) {
                this.errorAlert = {
                    message,
                    isError: true,
                };
            },
            onPortfolioFileChanged(event) {
                if (!(event && event.target && event.target.files[0])) return;

                this.portfolioFile = null;
                const file = event.target.files[0];

                if (file.size > 6291456) this.showError('Tamanho máximo permitido é 6MB');
                else {
                    this.portfolioFile = file;
                }
            },
            buildFormData() {
                let formData = new FormData();

                if (this.partnerTypeId) {
                    formData.append('partner_type_id', this.partnerTypeId.toString());
                }

                formData.append('email', this.email);
                formData.append('fullName', this.name);
                formData.append('phone', this.phone);
                formData.append('link', this.link);
                formData.append('midia', this.checkedMedias.join(', '));
                formData.append('afinity', this.checkedInterests.join(', '));
                formData.append('comment', this.proposal);

                if (this.portfolioFile) {
                    formData.append('filename', this.portfolioFile.name);
                    formData.append('filecontents', this.portfolioFile);
                }

                return formData;
            },
            sendEmail() {
                this.submitting = true;
                partnerService
                    .sendContactEmail(this.buildFormData())
                    .then(() => {
                        this.showSuccess(
                            'Seus dados foram enviados com sucesso e entraremos em contato em breve :)',
                            true
                        );
                        this.submitted = true;
                    })
                    .catch(() =>
                        this.showError(
                            'Não foi possível enviar as informações. Por favor, tente novamente.'
                        )
                    )
                    .then(() => (this.submitting = false));
            },
        },
    };
</script>